<template>
  <EditableArea :content="main" itemscope itemtype="https://schema.org/FAQPage" />
</template>

<script setup>
import { EditableArea } from "@magnolia/vue-editor";
defineOptions({
  inheritAttrs: false,
});
defineProps(["title", "metadata", "top", "main", "faqArea"]);
</script>
